import * as Yup from "yup";

import { SendNpCreditNOte, SendNpCreditNOteVariables } from "_graphql/mutation/__generated__/SendNpCreditNOte";
import { SendTreatyPlacingOrCovertNote, SendTreatyPlacingOrCovertNoteVariables } from "_graphql/mutation/__generated__/SendTreatyPlacingOrCovertNote";
import { sendCoverAndPlacingNotes, sendNPTreatyCreditNote } from "_graphql/visal/mutations/treaty";
import { useMatch, useSearch } from "react-location";
import { useTreaty, useTreatyReinsurer } from "hooks/data/use-treaties";

import { LocationGenerics } from "router/location";
import { Modal } from "components";
import { SendEmailForm } from "components/forms";
import _ from "lodash";
import numeral from "numeral";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMemo } from "react";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";

export const validationSchema = Yup.object().shape({
    message: Yup.string().required("Message is required"),
    subject: Yup.string().required("Subject is required"),
});

export default function SendDocumentsNonProportionalContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const { params } = useMatch<LocationGenerics>();
    const searchParams = useSearch<LocationGenerics>();
    const { treaty, loading: gettingTreaty } = useTreaty({ treatyId: params.treaty || "" });
    const [create, { loading }] = useMutation<SendNpCreditNOte, SendNpCreditNOteVariables>(sendNPTreatyCreditNote, {
        refetchQueries: ["Treaty"],
    });
    const { participant, loading: fetchingParticipant } = useTreatyReinsurer({ participationId: searchParams?.id || "" });

    const layer = useMemo(() => JSON.parse(treaty?.layer_limit || "[]").at(searchParams?.layer), [treaty?.layer_limit])


    const form = useFormik<any>({
        initialValues: {
            copied_emails: [],
            subject: "",
            message: "",
            include_attachment: false,
            should_send: 0,
            doc_type: []
        },
        validationSchema: validationSchema,
        onSubmit: async (variables) => {
            await create({
                variables: {
                    data: {
                        email_component: {
                            attachments: variables.attachments?.map((el: any) => el?.file_path) || [],
                            copied_email: variables.copied_emails?.map((el: any) => el) || [],
                            subject: variables.subject,
                            email_content: variables.message,
                        },
                        installment_type: layer?.installment_type || "",
                        layer: Number(searchParams?.layer) || 0,
                        limit: layer?.limit || "",
                        m_and_d_premium: numeral(layer?.m_and_d_premium).value(),
                        participant_id: Number(participant?.treaty_participation_id) || -1,
                        total_participation_percentage: participant?.treaty_participation_percentage,
                        treaty_id: Number(params.treaty || "0"),
                        uuid: searchParams?.id || "",
                    }
                },
            }).then(({ data }) => {
                if (data?.sendNPTreatyCreditNote) {
                    toast.success("Emails sent successfully");
                    refetch?.();
                    form.resetForm();
                } else {
                    toast.error("Failed to send emails");
                }
            });
        },
        onReset: () => {
            setOpen(false);
        },
    });

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            loading={fetchingParticipant || gettingTreaty}
            title={"Send Credit Note"}
            description="Draft an email to send to the participant(s) of this treaty."
            renderActions={() => (
                <>
                    <button
                        type="button"
                        disabled={loading}
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={wrapClick(form.handleSubmit)}
                    >
                        {loading ? "Sending emails..." : "Send Email"}
                    </button>
                </>
            )}
        >
            <SendEmailForm form={form} topForm={<div className="">
                <div className="bg-red-50 rounded-lg shadow-sm border border-red-200 p-4 mb-4">
                    <p className="text-sm  text-red-800 rounded-md">
                        This session will send Copy of Credit Notes along with any
                        attachments to {treaty?.treaty_to_associates?.length} associates of{" "}
                        {participant?.reinsurer?.re_company_name}
                    </p>
                </div>
            </div>} />
        </Modal>
    );
}
